module.exports = __webpack_public_path__ + "img/Casino2ez.09e3dabf.png";